export const projectsData = [
    {
      id: 1,
      title: "App World",
      date: "Janvier 2023",
      languages: ["React", "Html", "Sass"],
      infos:
        "Création d'une application de filtrage des pays.",
      img: "./assets/AppWorld.png",
      link: "https://github.com/SOA-P/Project-React-1",
    },
    {
      id: 2,
      title: "Externatic",
      date: "Février2023",
      languages: ["React", "Express" , "Css" , "mySql"],
      infos: "Refonte d'un site de consultants IT",
      img: "./assets/externatic.png",
      link: "https://github.com/WildCodeSchool/2022-09-JS-Lille-project-3-g2-externatic",
    },
    {
      id: 3,
      title: "Gaming School",
      date: "Novemnbre 2022",
      languages: ["Html", "Css",],
      infos:"Création d'un site vitrine d'une école de gaming",
      img: "./assets/gamingapp.png",
      link: "https://github.com/SOA-P/SiteVitrineAppGamingSchool",
    },
    {
      id: 4,
      title: "Randomovie",
      date: "Septembre 2022",
      languages: ["React", "Css" , "JavaScript"],
      infos:"Projet de formation , création d'une App mobile de taitement de film basé sur une API ",
      img: "./assets/Randomovie.png",
      link: "www.github.com",
  },
  {
    id: 5,
    title: "App Restau",
    date: "Décembre 2022",
    languages: ["html", "Sass"],
    infos: "Projet local , de site vitrine d'un restaurant",
    img: "./assets/restoApp.png",
    link: "https://github.com/SOA-P/SIteAppVitrineResto",
  },
  {
    id: 6,
    title: "Dayli journal",
    date: "Septembre 2022",
    languages: ["html" , "Css" , "JavaScript"],
    infos:"Projet de formation , création d'une App mobile de taitement de film basé sur une API ",
    img: "./assets/DayliP1.png",
    link: "www.github.com",
  },
  ];
  